import { createRouter } from "@vm/vue-core";

import comparisonRoutes from "@/comparison/routes";
import editorRoutes from "@/editor/routes";

const router = createRouter([editorRoutes, comparisonRoutes], {
  appBaseUrl: import.meta.env.BASE_URL,
});

export default router;
